import React from "react"
import Imageslider from "../../../Components/Imageslider/Imageslider"
import Navbar from "../../../Components/Navbar/Navbar"
import { greenmedimages } from "../../../Components/Body/ProjectProfile/images"
import Footer from "../../../Components/Footer/Footer"
import Whatsapp from "../../../Components/Body/Whatsapp/Whatsapp"

const Greenmedowgallery = () => {
  return (
    <>
      <Navbar />
      <Whatsapp />
      <div className="ongoing">
        <h1 className="title">Green Meadows</h1>
        <hr></hr>
        <Imageslider images={[...greenmedimages]} />
      </div>
      <Footer />

    </>
  )
}

export default Greenmedowgallery
